import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from 'antd'
import deleteLabel from '../actions/deleteLabel'

class LabelActions extends Component {
    _handleClickDelete = e => {
        e.preventDefault()
        const {labelId, barcode, onFetchLabels, label} = this.props

        deleteLabel(labelId, barcode, onFetchLabels, label)
    }

    render() {
        return (
            <td className='LabelActions'>
                <Button type='link' className='text-danger' onClick={this._handleClickDelete}>Delete</Button>
            </td>
        )
    }
}

LabelActions.propTypes = {
    labelId: PropTypes.string.isRequired,
    barcode: PropTypes.string.isRequired,
    onFetchLabels: PropTypes.func.isRequired,
}

export default LabelActions
